import { withInstall } from '@zoryn/utils'
import CascaderPanel from './src/index.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZCascaderPanel: SFCWithInstall<typeof CascaderPanel> =
  withInstall(CascaderPanel)

export default ZCascaderPanel
export * from './src/types'
export * from './src/config'
export * from './src/instance'
